/**
 * AIM · free gift auto-add
 *
 * Keeps the free Good Days Tracker (a $0 Shopify Digital Products item) in the cart
 * whenever Bexly AIM for Cats is in it, removes it when AIM is removed, and never lets
 * it go above 1. Runs after every cart request the theme makes (add / change / update /
 * clear) and once on load, then tells the theme to repaint the cart with `cart:update`.
 *
 * Config comes from <script id="aim-gift-config" type="application/json"> in theme.liquid.
 */
(function () {
  'use strict';
  var cfgEl = document.getElementById('aim-gift-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.giftVariantId || !cfg.productId) return;

  var GIFT = Number(cfg.giftVariantId);
  var AIM = Number(cfg.productId);
  var busy = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);

  function post(url, body) {
    return nativeFetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function repaint(cart) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = { resource: cart, sourceId: 'aim-gift', data: { itemCount: cart.item_count, source: 'aim-gift' } };
    document.dispatchEvent(ev);
  }

  function sync() {
    if (busy) return;
    busy = true;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasAim = cart.items.some(function (i) { return i.product_id === AIM; });
        var gift = cart.items.filter(function (i) { return i.variant_id === GIFT; })[0];
        if (hasAim && !gift) return post('cart/add.js', { items: [{ id: GIFT, quantity: 1 }] }).then(function () { return true; });
        if (!hasAim && gift) return post('cart/change.js', { id: gift.key, quantity: 0 }).then(function () { return true; });
        if (gift && gift.quantity > 1) return post('cart/change.js', { id: gift.key, quantity: 1 }).then(function () { return true; });
        return false;
      })
      .then(function (changed) {
        if (!changed) return;
        return nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(repaint);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) {
      p.then(function () { setTimeout(sync, 150); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
